import { apiClient } from '../../../../helpers/api_helper';

export const getAllDiscountVoucherData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/DiscountVoucher/GetAllDiscountVoucherList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getDiscountVoucherById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/DiscountVoucher/GetDiscountVoucherById?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getAllDiscountVoucherCodeByDiscountVouId = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/DiscountVoucher/GetAllDiscountVoucherCodeByDiscountVouId?DiscountVoucherId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};
export const getAllCustomerSelectList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Customer/GetCustomerSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createDiscountVoucher = async (data: FormData) => {
    try {
        const response = await apiClient.post('/api/v1/DiscountVoucher/InsertDiscountVoucher', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateDiscountVoucher = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/DiscountVoucher/UpdateDiscountVoucherCode', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};